<template>
  <footer class="footer">
    <b-container class="layout-footer">
      <b-row>
        <b-col md="6" lg="8">
          <div class="layout-footer__logo">
            <a :href="$t('resources.base_url')">
              <img src="/logo.svg" alt="Locomotion" />
            </a>
          </div>
          <div class="layout-footer__text">
            <p class="introduction">
              {{ $t("locomotion.motto") }}
            </p>

            <p class="social-media-icons">
              <a :href="$t('resources.facebook_url')" target="_blank" rel="noopener noreferrer">
                <b-icon icon="facebook" />
              </a>
              <a :href="$t('resources.instagram_url')" target="_blank" rel="noopener noreferrer">
                <b-icon icon="instagram" />
              </a>
              <a :href="$t('resources.youtube_url')" target="_blank" rel="noopener noreferrer">
                <b-icon icon="youtube" />
              </a>
              <a :href="$t('resources.linkedin_url')" target="_blank" rel="noopener noreferrer">
                <b-icon icon="linkedin" />
              </a>
            </p>
          </div>
        </b-col>
        <b-col md="3" lg="2" class="layout-footer__text align-self-end">
          <ul>
            <li>
              <a
                target="_blank"
                :href="$t('conditions.general_conditions_url')"
                :title="$t('components.layout.footer.terms.title')"
                >{{ $t("components.layout.footer.terms.link") }}</a
              >
            </li>
            <li>
              <a
                target="_blank"
                :href="$t('conditions.privacy_policy_url')"
                :title="$t('components.layout.footer.privacy_policy.title')"
                >{{ $t("components.layout.footer.privacy_policy.link") }}</a
              >
            </li>
          </ul>
        </b-col>
        <b-col md="3" lg="2" class="layout-footer__text">
          <h4>
            {{ $t("components.layout.footer.contact.title") }}
          </h4>
          <ul>
            <li>
              <a :href="$t('resources.media_request_url')">
                {{ $t("components.layout.footer.contact.media") }}</a
              >
            </li>
            <li>
              <a target="_blank" :href="$t('resources.newsletter_subscription_url')">
                {{ $t("components.layout.footer.contact.newsletter") }}
              </a>
            </li>
            <li>
              <b-link :href="'mailto:' + $t('locomotion.email')">
                {{ $t("locomotion.email") }}
              </b-link>
            </li>
          </ul>
        </b-col>
      </b-row>
    </b-container>

    <i18n path="components.layout.footer.license.text" tag="div" class="footer-license">
      <template #website>
        <a :href="$t('resources.source_code_url')" target="_blank">{{
          $t("components.layout.footer.license.website")
        }}</a>
      </template>
      <template #license>
        <a :href="$t('resources.license_url')" target="_blank">{{
          $t("components.layout.footer.license.agpl")
        }}</a>
      </template>
    </i18n>
  </footer>
</template>

<script>
export default {
  name: "LayoutFooter",
};
</script>

<style lang="scss">
@import "~bootstrap/scss/mixins/breakpoints";
footer.footer {
  background-color: $main-bg;
  border-top: 1px solid $light-grey;
}
.layout-footer.container {
  padding: 2.5rem;
  color: $locomotion-dark-green;

  display: flex;
  flex-direction: column;
  justify-content: space-around;

  .layout-footer__logo {
    margin-bottom: 0.5rem;

    img {
      height: 1.4rem;

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .layout-footer__text {
    font-size: 1rem;
    line-height: 18px;

    .introduction {
      margin-bottom: 2rem;
      a {
        text-decoration: none;
      }
    }

    h4 {
      margin-bottom: 2rem;
    }
    ul {
      padding: 0;
      margin: 0;
    }
    li {
      list-style: none;
      padding: 0;
      margin: 0 0 1rem 0;
      &:last-child {
        margin: 0;
      }
    }

    a {
      text-decoration: none;
      color: $locomotion-dark-green;

      &:hover {
        text-decoration: underline;
        color: $locomotion-light-green;
      }
    }
  }
  .social-media-icons {
    display: flex;
    gap: 1rem;
    margin-bottom: 0;

    img,
    svg {
      width: 2rem;

      &:hover {
        opacity: 0.8;
      }
    }
  }

  @include media-breakpoint-down(lg) {
    width: 100%;
    max-width: 100%;
  }

  @include media-breakpoint-down(sm) {
    text-align: center;

    .row {
      gap: 1.5rem;
    }

    .layout-footer__text h4 {
      margin-bottom: 1rem;
    }
    .layout-footer__text li {
      margin-bottom: 0.5rem;
    }

    .social-media-icons {
      justify-content: center;
    }
  }
}
.footer-license {
  background: $locomotion-dark-green;
  color: rgb(213, 219, 230);
  text-align: center;
  font-size: 0.75rem;
  padding: 0.5rem;
  a {
    color: white;
    &:hover {
      color: white;
    }
  }
}
</style>
